/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";

export function useSoftMemo<T>(value: T, fields?: readonly (keyof T)[]): T {
    return useMemo<T>(() => {
        return value;
    }, (fields || (Object.keys(value) as (keyof T)[])).map(field => value[field]));
}